import { Link } from 'react-router-dom';
import { site } from '../../content/site';
import { Container } from './Container';

/**
 * Wordmark plus the early access qualifier. No navigation menu: spec section 06
 * is explicit that the header carries the wordmark and "Maryland Early Access"
 * and nothing else, because every page has exactly one job.
 *
 * The bar is light rather than ink so that it reads as a separate element from
 * the dark hero photograph immediately below it.
 */
export function Header() {
  return (
    <header className="w-full border-b border-ink/10 bg-field">
      <Container className="flex min-h-16 flex-wrap items-center justify-between gap-x-4 gap-y-1 py-3">
        <Link
          to="/"
          aria-label={site.homeLinkLabel}
          className="text-lg font-semibold tracking-tight text-ink no-underline sm:text-xl"
        >
          {site.brandName}
        </Link>
        <span className="text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-signal sm:text-xs">
          {site.tagline}
        </span>
      </Container>
    </header>
  );
}
